/**
 * @generated SignedSource<<252c34418da9c8bdebcbc94e5ab32adf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AddExcludeOptInDispatchConditionInput = {
  clientMutationId?: string | null;
  messageDispatchId: string;
  optIn: boolean;
};
export type useDispatchConditions_AddExcludeOptInDispatchConditionMutation$variables = {
  input: AddExcludeOptInDispatchConditionInput;
};
export type useDispatchConditions_AddExcludeOptInDispatchConditionMutation$data = {
  readonly Admin: {
    readonly Message: {
      readonly addExcludeOptInDispatchCondition: {
        readonly clientMutationId: string | null;
      } | null;
    };
  };
};
export type useDispatchConditions_AddExcludeOptInDispatchConditionMutation = {
  response: useDispatchConditions_AddExcludeOptInDispatchConditionMutation$data;
  variables: useDispatchConditions_AddExcludeOptInDispatchConditionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "AdminMutationType",
    "kind": "LinkedField",
    "name": "Admin",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MessageAdminMutationSchema",
        "kind": "LinkedField",
        "name": "Message",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "input",
                "variableName": "input"
              }
            ],
            "concreteType": "AddExcludeOptInDispatchConditionPayload",
            "kind": "LinkedField",
            "name": "addExcludeOptInDispatchCondition",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "clientMutationId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useDispatchConditions_AddExcludeOptInDispatchConditionMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useDispatchConditions_AddExcludeOptInDispatchConditionMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "4ef3ed1bc5ff4073fabe1429f6434cb0",
    "id": null,
    "metadata": {},
    "name": "useDispatchConditions_AddExcludeOptInDispatchConditionMutation",
    "operationKind": "mutation",
    "text": "mutation useDispatchConditions_AddExcludeOptInDispatchConditionMutation(\n  $input: AddExcludeOptInDispatchConditionInput!\n) {\n  Admin {\n    Message {\n      addExcludeOptInDispatchCondition(input: $input) {\n        clientMutationId\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e04f0d5f7dd0872922b7458387f407de";

export default node;
